import { GP_GET_LIST, startType } from '../constants/action-types';
import { DEFAULT_PAGE_SIZE } from '../../CONST';


const initialState = {
  list: {
    garantiaPolicies: {
      data: [],
      pages: 0,
      count: 0,
      next: '',
      previous: '',
    },
  },
  loading: false,
};

const initLoading = state => ({
  ...state,
  loading: true,
});

const getList = (state, action) => ({
  ...state,
  loading: false,
  list: {
    ...state.list,
    garantiaPolicies: {
      ...state.list.garantiaPolicies,
      data: action.payload.results,
      pages: Math.ceil(action.payload.count / DEFAULT_PAGE_SIZE),
      count: action.payload.count,
      next: action.payload.next,
      previous: action.payload.previous,
    },
  },
});


function garantia(state = initialState, action) {
  switch (action.type) {
    case startType(GP_GET_LIST):
      return initLoading(state);
    case GP_GET_LIST:
      return getList(state, action);
    default:
      return state;
  }
}

export default garantia;
